/*
 * Genovare V2 search page. The server sends the first 50 results. This script fetches any further result pages,
 * keeps the counts right, and switches between All / Compounds / Pages with no reload. Without JavaScript the
 * first page of results and the normal page links are used.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-gv-search]');
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gv-tab]'));
  var groups = {
    compounds: root.querySelector('[data-gv-group="compounds"]'),
    pages: root.querySelector('[data-gv-group="pages"]'),
  };
  var lists = {
    compounds: root.querySelector('[data-gv-list="compounds"]'),
    pages: root.querySelector('[data-gv-list="pages"]'),
  };
  var labels = {
    compounds: root.getAttribute('data-compounds') || 'Compounds',
    pages: root.getAttribute('data-pages') || 'Pages',
  };
  var one = root.getAttribute('data-one') || 'result';
  var many = root.getAttribute('data-many') || 'results';
  var totalEl = root.querySelector('[data-gv-total]');
  var pager = root.querySelector('[data-gv-pagination]');
  var pageCount = parseInt(root.getAttribute('data-pages-total'), 10) || 1;
  var current = 'all';

  function count(kind) {
    return lists[kind] ? lists[kind].children.length : 0;
  }

  function refresh() {
    var c = count('compounds');
    var p = count('pages');
    var counts = { all: c + p, compounds: c, pages: p };
    tabs.forEach(function (tab) {
      var kind = tab.getAttribute('data-gv-tab');
      var badge = tab.querySelector('[data-gv-tab-count]');
      if (badge) badge.textContent = counts[kind];
      tab.setAttribute('aria-pressed', kind === current ? 'true' : 'false');
    });
    ['compounds', 'pages'].forEach(function (kind) {
      var label = root.querySelector('[data-gv-group-label="' + kind + '"]');
      if (label) label.textContent = labels[kind] + ' · ' + counts[kind];
      if (groups[kind]) groups[kind].hidden = counts[kind] === 0 || (current !== 'all' && current !== kind);
    });
    if (totalEl) {
      var shown = current === 'all' ? counts.all : counts[current];
      totalEl.textContent = shown + ' ' + (shown === 1 ? one : many);
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      current = tab.getAttribute('data-gv-tab');
      refresh();
    });
  });

  function loadMore() {
    if (pageCount < 2) return Promise.resolve();
    var jobs = [];
    for (var p = 2; p <= pageCount; p++) {
      (function (page) {
        var url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        jobs.push(
          fetch(url.toString(), { credentials: 'same-origin' })
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              return Array.prototype.slice.call(doc.querySelectorAll('[data-gv-search] [data-gv-kind]'));
            })
            .catch(function () {
              return [];
            })
        );
      })(p);
    }
    return Promise.all(jobs).then(function (results) {
      results.forEach(function (items) {
        items.forEach(function (li) {
          var kind = li.getAttribute('data-gv-kind');
          if (lists[kind]) lists[kind].appendChild(document.importNode(li, true));
        });
      });
      if (pager) pager.hidden = true;
    });
  }

  refresh();
  loadMore().then(refresh);
})();
